<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [closable]="true"
  [showHeader]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  [baseZIndex]="12000"
  (visibleChange)="onDialogVisibleChange($event)"
  (onHide)="onDialogVisibleChange(false)"
  styleClass="custom-modal api-explorer-dialog"
>
  <ng-template pTemplate="header">
    <div class="try-out-custom__modal-header" [ngStyle]="themeStyles">
      <div class="try-out-custom__modal-header-title">API Explorer</div>
      @if (tryOutSpec(); as spec) {
        <div class="try-out-custom__modal-header-controls">
          <label class="try-out-custom__label try-out-custom__label--inline try-out-custom__modal-header-label">Server:</label>
          <div class="try-out-custom__modal-header-select">
            <select
              class="try-out-custom__server-select"
              [ngModel]="selectedTryOutServerUrl()"
              (ngModelChange)="selectedTryOutServerUrl.set($event)"
            >
              @for (server of spec.servers || []; track server.url) {
                <option [value]="server.url">{{ server.url }}</option>
              }
            </select>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <div class="lib-api-explorer-root" [ngStyle]="themeStyles">
    <div class="try-out-modal">
      @if (tryOutYamlLoading()) {
        <div class="try-out-modal--loading try-out-modal--overlay">
          <div class="try-out-modal--loading-spinner"></div>
          <p>Loading API documentation...</p>
        </div>
      }

      @if (tryOutYamlError()) {
        <div class="try-out-modal--error">
          {{ tryOutYamlError() }}
        </div>
      }

      @if (!tryOutYamlError() && tryOutSpec()) {
        <div class="try-out-custom">
          <div class="try-out-custom__layout">
            <div class="try-out-custom__operations-panel">
              <div class="try-out-custom__operations">
                @for (operation of tryOutOperations(); track operation.id) {
                  <div
                    class="try-out-custom__card"
                    [class.try-out-custom__card--active]="isTryOutOperationExpanded(operation.id)"
                  >
                    <button type="button" class="try-out-custom__summary" (click)="toggleTryOutOperation(operation.id)">
                      <div class="try-out-custom__summary-main">
                        <span
                          class="try-out-custom__summary-icon"
                          [class.checked]="isTryOutOperationExpanded(operation.id)"
                          aria-hidden="true"
                        ></span>
                        <div class="try-out-custom__summary-copy">
                          <span class="try-out-custom__summary-title">{{ operation.summary || operation.path }}</span>
                        </div>
                        <span [class]="getTryOutMethodClass(operation.method)">{{ operation.method }}</span>
                      </div>
                    </button>
                  </div>
                }
              </div>
            </div>

            <aside class="try-out-custom__response-panel">
              @if (activeTryOutOperation(); as activeOperation) {
                <div class="try-out-custom__response-card">
                  <div class="try-out-custom__workspace-header">
                    <div>
                      <h3 class="try-out-custom__response-title">
                        {{ activeOperation.summary || activeOperation.path || 'Operation Details' }}
                      </h3>
                      <div class="try-out-custom__path try-out-custom__path--detail">{{ activeOperation.path }}</div>
                    </div>
                    <span [class]="getTryOutMethodClass(activeOperation.method)">
                      {{ activeOperation.method }}
                    </span>
                  </div>

                  @if (activeOperation.description) {
                    <p class="try-out-custom__description try-out-custom__description--workspace">{{ activeOperation.description }}</p>
                  }

                  @if (activeOperation.parameters.length) {
                    <div class="try-out-custom__section try-out-custom__section--surface">
                      <h3 class="try-out-custom__section-title">Parameters</h3>
                      <div class="try-out-custom__param-grid">
                        @for (param of activeOperation.parameters; track param.name) {
                          <div class="try-out-custom__param">
                            <label class="try-out-custom__label">
                              {{ param.name }}
                              <span class="try-out-custom__param-meta">({{ param.in }})</span>
                            </label>
                            <input
                              class="try-out-custom__input"
                              [value]="tryOutRequestState()[activeOperation.id]?.params?.[param.name] || ''"
                              (input)="setTryOutParamValue(activeOperation.id, param.name, $any($event.target).value)"
                              [placeholder]="param.example || ('Enter ' + param.name)"
                            />
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (activeOperation.requestContentType) {
                    <div class="try-out-custom__section try-out-custom__section--surface">
                      <h3 class="try-out-custom__section-title">Request Body</h3>
                      <div class="try-out-custom__content-type">{{ activeOperation.requestContentType }}</div>
                      <textarea
                        class="try-out-custom__textarea"
                        [value]="tryOutRequestState()[activeOperation.id]?.bodyText || ''"
                        (input)="setTryOutRequestBody(activeOperation.id, $any($event.target).value)"
                        rows="10"
                      ></textarea>
                    </div>
                  }

                  <div class="try-out-custom__actions try-out-custom__actions--workspace">
                    <button type="button" class="try-out-custom__action try-out-custom__action--primary" (click)="executeCustomTryOut(activeOperation)">
                      Execute
                    </button>
                    <button type="button" class="try-out-custom__action try-out-custom__action--secondary" (click)="resetTryOutOperation(activeOperation)">
                      Reset
                    </button>
                  </div>

                  @if (activeTryOutExecutionResult()?.curl) {
                    <div class="try-out-custom__section try-out-custom__section--surface">
                      <h3 class="try-out-custom__section-title">cURL</h3>
                      <pre class="try-out-custom__code">{{ activeTryOutExecutionResult()?.curl }}</pre>
                    </div>
                  }

                  <div class="try-out-custom__section try-out-custom__section--surface">
                    <h3 class="try-out-custom__section-title">Response</h3>
                    @if (activeTryOutExecutionResult()?.loading) {
                      <div class="try-out-custom__response-state">Executing request...</div>
                    } @else if (activeTryOutExecutionResult()?.status) {
                      <div class="try-out-custom__response-status">
                        Status: {{ activeTryOutExecutionResult()?.status }} {{ activeTryOutExecutionResult()?.statusText }}
                      </div>
                    } @else if (!activeTryOutExecutionResult()?.error) {
                      <div class="try-out-custom__response-placeholder">
                        Execute the selected operation to view the response here.
                      </div>
                    }
                    @if (activeTryOutExecutionResult()?.error) {
                      <div class="try-out-custom__response-error">
                        {{ activeTryOutExecutionResult()?.error }}
                      </div>
                    }
                    @if (activeTryOutExecutionResult()?.body) {
                      <pre class="try-out-custom__code">{{ activeTryOutExecutionResult()?.body }}</pre>
                    }
                  </div>
                </div>
              } @else {
                <div class="try-out-custom__response-card">
                  <div class="try-out-custom__response-placeholder">
                    Select an operation from the left to view its request details.
                  </div>
                </div>
              }
            </aside>
          </div>
        </div>
      }
    </div>
  </div>
</p-dialog>
